export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO = 'RESTO365_INGREDIENTS_NUTRITIONAL_INFO'

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_CREATE = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/createNutritionalInfo`

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_UPDATE = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/updateNutritionalInfo`

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_DELETE = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/deleteNutritionalInfo`

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_LIST = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/listNutritionalInfo`

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_RESTORE = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/restoreNutritionalInfo`

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_SEARCH = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/searchNutritionalInfo`

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_GENERATE_MENU = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/generateMenu`

export const RESTO365_INGREDIENTS_NUTRITIONAL_INFO_S3_GET_FILE = `${RESTO365_INGREDIENTS_NUTRITIONAL_INFO}/s3/getFile`
